import module from 'cliente/module.js'

const schema = {
  idMoneda: 'numbre',
  activo: 'boolean',
}

export class ClienteInformacionBancosService {
  constructor ($http) {
    this.$http = $http
  }

  get (idCliente) {
    return this.$http.get('/kendu/clientes/cliente/informacion/bancos', {
      params: {idCliente: idCliente},
      schema
    })
  }

  post (idCliente, data) {
    return this.$http.post('/kendu/clientes/cliente/informacion/bancos', data, {
      params: {idCliente: idCliente},
      schema
    })
  }
}

module.service('ClienteInformacionBancos', ClienteInformacionBancosService)



// WEBPACK FOOTER //
// ./src/cliente/services/Informacion/Bancos.js